module.exports = {
	"_args": [
		[
			{
				"raw": "tough-cookie@~2.3.3",
				"scope": null,
				"escapedName": "tough-cookie",
				"name": "tough-cookie",
				"rawSpec": "~2.3.3",
				"spec": ">=2.3.3 <2.4.0",
				"type": "range"
			},
			"/home/carparks.wipehero/source-carparks/node_modules/request"
		]
	],
	"_from": "tough-cookie@>=2.3.3 <2.4.0",
	"_id": "tough-cookie@2.3.4",
	"_inCache": true,
	"_location": "/tough-cookie",
	"_nodeVersion": "8.9.4",
	"_npmOperationalInternal": {
		"host": "s3://npm-registry-packages",
		"tmp": "tmp/tough-cookie_2.3.4_1519684165015_0.21877903579709823"
	},
	"_npmUser": {
		"name": "jstash",
		"email": "jstash@gmail.com"
	},
	"_npmVersion": "5.6.0",
	"_phantomChildren": {},
	"_requested": {
		"raw": "tough-cookie@~2.3.3",
		"scope": null,
		"escapedName": "tough-cookie",
		"name": "tough-cookie",
		"rawSpec": "~2.3.3",
		"spec": ">=2.3.3 <2.4.0",
		"type": "range"
	},
	"_requiredBy": [
		"/request",
		"/request-promise"
	],
	"_resolved": "https://registry.npmjs.org/tough-cookie/-/tough-cookie-2.3.4.tgz",
	"_shasum": "ec60cee38ac675063ffc97a5c18970578ee83655",
	"_shrinkwrap": null,
	"_spec": "tough-cookie@~2.3.3",
	"_where": "/home/carparks.wipehero/source-carparks/node_modules/request",
	"author": {
		"name": "Jeremy Stashewsky",
		"email": "jstashewsky@salesforce.com"
	},
	"bugs": {
		"url": "https://github.com/salesforce/tough-cookie/issues"
	},
	"contributors": [
		{
			"name": "Alexander Savin"
		},
		{
			"name": "Ian Livingstone"
		},
		{
			"name": "Ivan Nikulin"
		},
		{
			"name": "Lalit Kapoor"
		},
		{
			"name": "Sam Thompson"
		},
		{
			"name": "Sebastian Mayr"
		}
	],
	"dependencies": {
		"punycode": "^1.4.1"
	},
	"description": "RFC6265 Cookies and Cookie Jar for node.js",
	"devDependencies": {
		"async": "^1.4.2",
		"string.prototype.repeat": "^0.2.0",
		"vows": "^0.8.1"
	},
	"directories": {},
	"dist": {
		"integrity": "sha512-TZ6TTfI5NtZnuyy/Kecv+CnoROnyXn2DN97LontgQpCwsX2XyLYCC0ENhYkehSOwAp8rTQKc/NUIF7BkQ5rKLA==",
		"shasum": "ec60cee38ac675063ffc97a5c18970578ee83655",
		"tarball": "https://registry.npmjs.org/tough-cookie/-/tough-cookie-2.3.4.tgz",
		"fileCount": 9,
		"unpackedSize": 245484
	},
	"engines": {
		"node": ">=0.8"
	},
	"files": [
		"lib"
	],
	"gitHead": "e4dfb0aec5d25e9e982805417a5d936071badc17",
	"homepage": "https://github.com/salesforce/tough-cookie",
	"keywords": [
		"HTTP",
		"cookie",
		"cookies",
		"set-cookie",
		"cookiejar",
		"jar",
		"RFC6265",
		"RFC2965"
	],
	"license": "BSD-3-Clause",
	"main": "./lib/cookie",
	"maintainers": [
		{
			"name": "awaterma",
			"email": "awaterma@awaterma.net"
		},
		{
			"name": "jstash",
			"email": "jstash@gmail.com"
		},
		{
			"name": "maratto",
			"email": "marat+npm@salesforce.com"
		},
		{
			"name": "ruoho",
			"email": "clint@ruoho.org"
		}
	],
	"name": "tough-cookie",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git://github.com/salesforce/tough-cookie.git"
	},
	"scripts": {
		"suffixup": "curl -o public_suffix_list.dat https://publicsuffix.org/list/public_suffix_list.dat && ./generate-pubsuffix.js",
		"test": "vows test/*_test.js"
	},
	"version": "2.3.4"
};


//////////////////
// WEBPACK FOOTER
// ./~/tough-cookie/package.json
// module id = 1020
// module chunks = 0